import React from "react";
import { location } from "../mock";
import { MapPin } from "lucide-react";

const Location = () => (
  <section id="location-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${location.bg})`, backgroundSize: "cover" }}>
    <div className="absolute inset-0 bg-[#f8f2e8]/90" />
    <img src={location.flower} alt="" className="ornament left-0 top-16 w-36 opacity-70" />
    <img src={location.multiFlowers} alt="" className="ornament right-0 bottom-0 w-40 opacity-60" />
    <div className="relative max-w-[1320px] mx-auto px-5 lg:px-8">
      <div className="section-head">
        <p className="eyebrow">Location Map</p>
        <div className="divider-leaf my-3" />
        <h2 className="h-title">In the Heart of the City. Away from the Chaos.</h2>
        <p className="mt-4 text-[#4a4a44] max-w-[720px] mx-auto">Located in the most connected, developed, and livable sector of Greater Noida West—yet free from crowding.</p>
      </div>

      <div className="grid lg:grid-cols-5 gap-8 items-center">
        <div className="lg:col-span-3">
          <a href={location.map} target="_blank" rel="noreferrer" className="block rounded-[22px] overflow-hidden shadow-[0_24px_60px_rgba(31,58,42,0.18)] border border-[#c26a4a]/30">
            <img src={location.map} alt="Location Map" className="w-full h-[380px] md:h-[520px] object-cover hover:scale-105 transition-transform duration-700" />
          </a>
        </div>
        <div className="lg:col-span-2 space-y-3">
          {location.advantages.map((a, i) => (
            <div key={i} className="flex items-center gap-4 bg-white/80 border border-[#c26a4a]/25 rounded-xl p-4 card-lift">
              <div className="w-12 h-12 shrink-0 rounded-full bg-[#2a3d5c] flex items-center justify-center">
                <img src={a.icon} alt="" className="w-6 h-6" style={{ filter: "brightness(0) invert(1)" }} />
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="text-[#c26a4a] mt-1 shrink-0" />
                <p className="font-serif-e text-[17px] text-[#2a3d5c] leading-snug">{a.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Location;
